import { FlaskConical, Link2 } from "lucide-react";

const CONF = {
  low: "text-atlas-secondary border-atlas-secondary/40",
  medium: "text-atlas-orange border-atlas-orange/50",
  high: "text-atlas-cyan border-atlas-cyan/50",
};

export const SharedNote = ({ hyp }) =>
  hyp.shared_from ? (
    <div className="text-[9px] font-mono uppercase tracking-wider text-amber-300/80 mb-1.5" data-testid={`hypothesis-shared-${hyp.uid}`}>
      Shared from incident lead reading{hyp.shared_from_region ? ` · ${hyp.shared_from_region}` : ""}
    </div>
  ) : null;

export const HypothesisCard = ({ hyp, onSelectObservation }) => {
  const conf = CONF[hyp.confidence] || CONF.low;
  return (
    <div
      data-testid={`hypothesis-card-${hyp.uid}`}
      className="ledger-row border-b border-white/10 border-l-2 border-l-atlas-cyan p-3 cyan-glow"
    >
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-1.5">
          <FlaskConical className="w-3 h-3 text-atlas-cyan" strokeWidth={2} />
          <span className="text-[9px] font-mono tracking-widest text-atlas-cyan">HYPOTHESIS</span>
        </div>
        {typeof hyp.calibrated_score === "number" ? (
          <div className="flex flex-col items-end" data-testid={`hypothesis-calibrated-${hyp.uid}`}>
            <span className={`text-[9px] font-mono uppercase px-1.5 py-0.5 border ${conf}`}>
              {Math.round(hyp.calibrated_score * 100)}% calibrated
            </span>
            <span className="text-[8px] font-mono text-atlas-secondary/75 mt-0.5">
              AI {Math.round(hyp.confidence_score * 100)}% · {hyp.calibrated_n > 0 ? `${hyp.calibrated_n} outcomes` : "prior"}
            </span>
          </div>
        ) : (
          <span className={`text-[9px] font-mono uppercase px-1.5 py-0.5 border ${conf}`}>
            {hyp.confidence} · {Math.round(hyp.confidence_score * 100)}%
          </span>
        )}
      </div>

      <div className="text-sm font-display text-white mb-1.5">{hyp.name}</div>
      <SharedNote hyp={hyp} />
      {hyp.plain_summary && (
        <div
          data-testid={`hypothesis-plain-${hyp.uid}`}
          className="text-[12px] text-white/95 leading-snug bg-atlas-cyan/5 border-l-2 border-atlas-cyan/40 pl-2 py-1 mb-2"
        >
          <span className="block text-[8px] font-mono uppercase tracking-widest text-atlas-cyan/60">In plain English</span>
          {hyp.plain_summary}
        </div>
      )}
      <p className="text-[11px] text-atlas-secondary leading-relaxed mb-2">{hyp.statement}</p>

      {hyp.discriminating_predictions?.length > 0 && (
        <div className="mb-2">
          <div className="text-[9px] uppercase tracking-widest text-atlas-cyan/80 font-mono mb-0.5">
            Discriminating prediction
          </div>
          <div className="text-[11px] text-atlas-foreground/90 font-mono leading-snug">
            {hyp.discriminating_predictions[0]}
          </div>
        </div>
      )}

      <button
        onClick={() => onSelectObservation && onSelectObservation(hyp.observation_uid)}
        data-testid={`hypothesis-link-${hyp.uid}`}
        className="flex items-center gap-1 text-[10px] font-mono text-atlas-secondary/85 hover:text-atlas-cyan transition-colors"
      >
        <Link2 className="w-3 h-3" />
        OBS {hyp.observation_uid.slice(0, 8)}
      </button>
    </div>
  );
};
